(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-expand"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const clickable = document.getElementById('imageClickable');
    const overlay = document.getElementById('fullscreenOverlay');

    // Open fullscreen on click/tap
    clickable.addEventListener('click', function(e) {
      e.stopPropagation();
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    // Close fullscreen on overlay click/tap
    overlay.addEventListener('click', function(e) {
      e.stopPropagation();
      overlay.classList.remove('active');
      document.body.style.overflow = 'auto';
    });
  });

  } catch(e) { console.error(e); }
})();
})();
